module.exports = __webpack_public_path__ + "img/globeDarkMode.919c773e.gif";